import { render, staticRenderFns } from "./BuyerOrderInvoice.vue?vue&type=template&id=62512ed6&"
import script from "./BuyerOrderInvoice.vue?vue&type=script&lang=js&"
export * from "./BuyerOrderInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports